// extracted by mini-css-extract-plugin
export default {"zoomModal":"R2-z","image":"S2-z","button":"T2-z","isOverlayShown":"U2-z"};